import React from 'react';
import PropTypes from 'prop-types';
import Loader from './loader.jsx';
import TermView from './term_view.ui.jsx';

import { loadTerms, setCurrentTerm } from 'actions/terms';
import { analyticsEvent } from '../actions/analytics';

import { connect } from 'react-redux';
import termViewSelector from 'selectors/component_selectors/term_view_selector';
import { addAural } from 'actions/aural_notification';

export class TermViewWrapper extends React.PureComponent {
    static propTypes = {
        loadTerms: PropTypes.func.isRequired,
        setCurrentTerm: PropTypes.func.isRequired,
        params: PropTypes.shape({ termId: PropTypes.string.isRequired }),
        addAural: PropTypes.func.isRequired,
    };
    state = { busy: true, loaded: false };
    async componentDidMount() {
        const {
            loadTerms,
            setCurrentTerm,
            params: { termId },
        } = this.props;
        await setCurrentTerm(termId);
        this.setState({ busy: false });
        loadTerms().then(foo => {
            this.setState({
                loaded: true,
            });
        });
    }

    render() {
        return this.state.busy ? <Loader /> : <TermView {...this.props} />;
    }

    componentDidUpdate(_, oldState) {
        const { loaded } = this.state;
        if (loaded && !oldState.loaded) {
            this.props.addAural('Loading complete');
        }
    }
}

export default connect(
    termViewSelector,
    {
        loadTerms,
        setCurrentTerm,
        analyticsEvent,
        addAural,
    }
)(TermViewWrapper);



// WEBPACK FOOTER //
// ./src/components/term_view.jsx